import React from 'react';
import Topbar from '../Topbar/Topbar';
import MiddleBar from '../MiddleBar/MiddleBar';
import Navbar from '../Navbar/nav';
function Combaintop() {
    return (
        <>
            <Topbar />
            <MiddleBar />
            <Navbar />
        </>
    );
}

export default Combaintop;
